export default __webpack_public_path__ + "static/media/people.97f7ae60.svg";